export const POPULAR_COUNTRY_CODES = ["DK", "FI", "NO", "PL", "SE"];
